import React from 'react';
import Carousel from './Carousel';
import CircularText from './CircularText';

export const About = ({ className = "" }) => {
  const data = [
    {
      id: 1,
      title: "Who I Am And What I Do",
      desc: "I am extremely fascinated by science, engineering and technology.",
    },
  ];

  return (
    <>
      <Carousel />
      <section className={`about topMargin bottomMargin ${className}`}>
        <div className="container flex">
          {data.map((value) => (
            <React.Fragment key={value.id}>
              <div className="lef mtop">
                <div className="heading">
                  <h3 className="animated-text">About Me</h3>
                  <h1 className="animated-text">{value.title}</h1>
                </div>
                <p>{value.desc}</p>
                <button className="primary-btn btn-led">
                  Contact Me
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>

                  <span className="line2"></span>
                  <span className="line2"></span>
                  <span className="line2"></span>
                  <span className="line2"></span>
                </button>
              </div>
              <div className="right">
                <CircularText />
              </div>
            </React.Fragment>
          ))}
        </div>
      </section>
    </>
  );
};